import { render } from "./AccueilSection.vue?vue&type=template&id=424be012"
import script from "./AccueilSection.vue?vue&type=script&lang=js"
export * from "./AccueilSection.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__